import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AudioProvider } from "@/context/AudioContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AudioPlayerBar from "@/components/AudioPlayerBar";
import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import News from "@/pages/News";
import Concerts from "@/pages/Concerts";
import Editions from "@/pages/Editions";
import Wagram from "@/pages/Wagram";
import TypoLab from "@/pages/TypoLab";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Support from "@/pages/Support";
import About from "@/pages/About";
import Press from "@/pages/Press";
import Jukebox from "@/pages/Jukebox";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <AudioPlayerBar />}
    </>
  );
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-jm-ink min-h-screen text-jm-bone">
      <AuthProvider>
        <AudioProvider>
          <BrowserRouter>
            <ScrollManager />
            <Chrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/artistes" element={<Artists />} />
                <Route path="/artistes/small-cow" element={<Navigate to="/artistes/smallco" replace />} />
                {/* Adresses courtes des projets (cartes de visite, QR codes, partage) */}
                <Route path="/sirin" element={<Navigate to="/artistes/sirin-codal" replace />} />
                <Route path="/nicodri" element={<Navigate to="/artistes/nicodri-trio" replace />} />
                <Route path="/wib" element={<Navigate to="/artistes/wib-organic-trio" replace />} />
                <Route path="/bam" element={<Navigate to="/artistes/bam-the-howls" replace />} />
                <Route path="/smallco" element={<Navigate to="/artistes/smallco" replace />} />
                <Route path="/artistes/:slug" element={<ArtistDetail />} />
                <Route path="/actualites" element={<News />} />
                <Route path="/concerts" element={<Concerts />} />
                <Route path="/typo" element={<TypoLab />} />
                <Route path="/catalogue-wagram" element={<Wagram />} />
                <Route path="/wagram" element={<Navigate to="/catalogue-wagram" replace />} />
                <Route path="/editions" element={<Editions />} />
                <Route path="/boutique" element={<Shop />} />
                <Route path="/boutique/:id" element={<ProductDetail />} />
                <Route path="/soutenir" element={<Support />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/presse" element={<Press />} />
                <Route path="/jukebox" element={<Jukebox />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Chrome>
          </BrowserRouter>
        </AudioProvider>
      </AuthProvider>
      <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#14161F", border: "1px solid rgba(197,160,89,0.3)", color: "#F3F0EA" } }} />
    </div>
  );
}

export default App;
